import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TableConfig } from 'app/shared/util/table-config.utils';

import { ToolStatusHistory } from 'app/shared/models/tool-status-history.model';

import { TableColumnComponent } from '@components/custom-table/components/column/table-column.component';
import { TranslateService } from "@ngx-translate/core";
import { Log } from "ng2-logger";
import { ToolStatus } from "@app/tool/model/enums/tool-status";

@Component({
    selector: 'app-status-history-table',
    templateUrl: './status-history-table.component.html',
    styleUrls: ['./status-history-table.component.scss']
})
export class StatusHistoryTableComponent implements OnInit {
    _logger = Log.create(StatusHistoryTableComponent.name);
    @ViewChild('date', {static: true}) dateColumn: TableColumnComponent;

    @Input() toolStatusHistory: ToolStatusHistory[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();

    filterStatusList = [];

    constructor(private translateService: TranslateService) {
        this.filterStatusList = this.buildStatusFilterColumnKeys();
        this.translateService.onLangChange.subscribe(() => {
            this.filterStatusList = this.buildStatusFilterColumnKeys();
            this._logger.info('onLangChange:: Language keys', this.filterStatusList);
        });
    }

    ngOnInit() {
        this.dateColumn.sort = {
            active: true,
            direction: 'desc'
        };
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange:: ', this.tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange:: ', this.tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange:: ', this.tableConfig);
        this.filterChange.emit(tableConfig);
    }

    buildStatusFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {name: this.translateService.instant("generic.statuses.atAtomStation"), value: ToolStatus.AT_ATOM_STATION},
            {name: this.translateService.instant("generic.statuses.storedInLift"), value: ToolStatus.STORED_IN_LIFT},
            {name: this.translateService.instant("generic.statuses.inTransport"), value: ToolStatus.IN_TRANSPORT},
            {name: this.translateService.instant("generic.statuses.atLine"), value: ToolStatus.AT_LINE},
            {name: this.translateService.instant("generic.statuses.atFacility"), value: ToolStatus.AT_FACILITY},
            {name: this.translateService.instant("generic.statuses.deleted"), value: ToolStatus.DELETED},
        ];
    }
}
